<template>
  <div class="page-main-bg half-circle-bg">
    <v-container class="main-container team-container">
      <div v-if="isPageLoading" class="pt-15">
        <Loader v-bind="loaderProps" />
      </div>
      <template v-else>
        <!------------------------------------------->
        <!-------------Breadcrumbs-------------------->
        <!-------------------------------------------->
        <tool-bar
          class="pl-3"
          v-bind="toolBarProps"
          @setDate="setDate"
          @toggleCards="toggleShowStats"
          @edit="setShowEditNameModal(true)"
        />
        <v-container>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <!------------------------------------------->
              <!--Realestate status and available actions-->
              <!------------------------------------------->
              <ClientDetailsToolbar
                v-bind="clientToolbarProps"
                @addNewUnit="extraUnitsState = true"
                @completeUnitData="singleUnitDialogState = true"
                @change-show-hectar="changeShowHectar"
                @showRateDailog="showRateModal = $event"
              />
              <!------------------------------------------->
              <!--------Rented realestate statistics-------->
              <!------------------------------------------->
              <ClientDetailsTiles
                v-if="
                  (isPartiallyRented || realEstateStatusEn === 'rented') &&
                  $hasPermission('statistics', 'statistics', 'list')
                "
                v-show="cardsInfoState"
                v-bind="clientDetailsTilesProps"
              />
            </v-col>
            <v-col md="6" sm="12" cols="12">
              <!------------------------------------------->
              <!-------------Realestate details------------->
              <!-------------------------------------------->
              <v-layout class="sidedetails__layout">
                <v-flex>
                  <v-tabs
                    class="tabs-container"
                    color="primary"
                    align-with-title
                    right
                    v-model="allTabs.tab1"
                  >
                    <v-tab
                      v-for="tab in renderTabs1"
                      :key="tab.title"
                      color="#737373"
                      class="font-14"
                      style="margin-right: 8px"
                    >
                      {{ tab.title }}
                    </v-tab>
                    <v-btn
                      icon
                      :style="
                        (allTabs.tab1 || isRealEstateRented) &&
                        'pointer-events: none'
                      "
                      @click="openDialogState"
                      class="ms-auto"
                    >
                      <div
                        v-if="!allTabs.tab1 && !isRealEstateRented"
                        class="ml-4"
                        color="grey"
                      >
                        <img
                          src="@/assets/Icons_Legacy/edit.svg"
                          alt="mdi-edit"
                        />
                      </div>
                    </v-btn>
                    <v-btn
                      v-if="allTabs.tab1 && !realEstate?.parentId"
                      class="add-btn add__property__btn px-1 py-3 mt-4 ml-4"
                      depressed
                      x-small
                      @click="responsibleModalStatus = true"
                    >
                      <div color="purple">
                        <img
                          src="@/assets/Icons_Legacy/add.svg"
                          alt="mdi-plus"
                        />
                      </div>
                    </v-btn>
                  </v-tabs>
                  <div class="contentSection">
                    <v-tabs-items v-model="allTabs.tab1">
                      <v-tab-item
                        v-for="tab in renderTabs1"
                        :key="tab.title"
                        :eager="true"
                        style="height: 190px"
                      >
                        <Component
                          :is="tab.component"
                          v-bind="{
                            realEstate: clientDetailsInfoCardProps?.realEstate,
                            propertyParties: tabsMembersData[2]
                          }"
                          @completeUnitData="singleUnitDialogState = true"
                          @reloadProperty="getRealEstateProperty"
                        />
                      </v-tab-item>
                    </v-tabs-items>
                  </div>
                </v-flex>
              </v-layout>
            </v-col>
            <v-col
              md="6"
              sm="12"
              cols="12"
              class="details__list__tab properties__cards"
            >
              <!------------------------------------------->
              <!-------------Realestate owners info--------->
              <!-------------------------------------------->
              <DetailsTabs
                v-bind="detailsTabsProps"
                @openSelectModel="bankSelectModelDialogState = true"
                @openBeneficiaryModal="beneficiaryModalStatus = true"
                @edit="editBeneficiaryHandler"
                @delete="deleteBeneficiaryHandler"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="file__listbond__tab properties__cards"
            >
              <!------------------------------------------->
              <!-------------Realestate bonds-------------->
              <!-------------------------------------------->
              <FileListCard
                v-bind="listBondsProps"
                @showAddBondModal="showAddBondModal = true"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="file__listcontract__tab properties__cards"
            >
              <!------------------------------------------->
              <!-------------Realestate contracts---------->
              <!------------------------------------------->
              <FileListCard
                v-bind="listContractsProps"
                @showAddContractModal="openAddContractModal"
              />
            </v-col>
            <v-col cols="12" md="4" class="file__list__tab properties__cards">
              <!--Deposit and expenses tabs-->
              <v-card
                class="d-flex flex-column document__bond__contract__list__cards mb-3"
                height="350"
              >
                <v-card-title class="px-5 py-0">
                  <v-tabs
                    class="tabs-container"
                    color="black"
                    align-with-title
                    right
                    v-model="tab"
                  >
                    <v-tabs-slider color="black"></v-tabs-slider>
                    <v-tab
                      v-for="tab in tabs"
                      :key="tab.component"
                      color="#9F9FAC"
                      class="font-16 mr-0"
                    >
                      {{ tab.title }}
                    </v-tab>
                  </v-tabs>
                </v-card-title>

                <v-card-text class="mt-4 px-0 pb-1">
                  <v-tabs-items v-model="tab">
                    <v-tab-item
                      v-for="tab in tabs"
                      :key="tab.component"
                      :eager="true"
                    >
                      <component
                        :is="tab.component"
                        v-bind="generateTabProps(tab)"
                        @showExpensesLimitModal="changeExpensesModalState(true)"
                      />
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              md="4"
              class="file__listcontract__tab properties__cards"
            >
              <!------------------------------------------->
              <!--Realestate documents-->
              <!-------------------------------------------->
              <FileListCard
                v-bind="listDocumentsProps"
                @documentFileUploader="openAttachmentsModalHandler"
                @delete-document="deleteDocument"
              />
            </v-col>
            <v-col cols="12" md="4">
              <!------------------------------------------->
              <!-------------Realestate images slider------>
              <!-------------------------------------------->
              <DetailsSlider
                :property-data="realEstate"
                @update-property-image="updatePropertyImages"
                @show-image="openImageDialog"
                v-if="hasAttacheRealStateImagesPermission"
              />
            </v-col>
            <v-col cols="12" md="4">
              <!------------------------------------------->
              <!-------------Realestate blueprint---------->
              <!------------------------------------------->
              <BlueprintImages
                :property-data="realEstate"
                @set-blueprint-image="setBlueprintImage"
                @show-image="openImageDialog"
              />
            </v-col>

            <v-col cols="12" md="12" sm="12">
              <!------------------------------------------->
              <!--Building or compound interanl extra unit-->
              <!-------------------------------------------->
              <ClientDetailsRealEstateList
                v-if="hasUnits"
                cols="3"
                :PropertyId="realEstate._id"
                :real-estate-type="realEstateType"
                :type="false"
                :isFromDetails="true"
                ref="innerUnits"
                @realEstates="realEstates = $event"
              />
            </v-col>
          </v-row>
        </v-container>
      </template>
    </v-container>
    <!------------------------------------------->
    <!-------------Edit realestate modal-------->
    <!-------------------------------------------->
    <unit-modal
      v-if="dialogState"
      :propertyInfo="realEstate"
      :dialogState="dialogState"
      @changeDialogState="dialogState = $event"
      @closed-property-dialog="closeAddDialog"
      @refreshPropertiesList="getRealEstateDetails"
    />
    <!-------------------------------------------->
    <!----Add extra units to realestate modal----->
    <!-------------------------------------------->
    <addExtraUnits
      v-if="extraUnitsState"
      :extraUnitsState="extraUnitsState"
      :buildingType="buildingType"
      :realEstatePurpose="realEstatePurpose"
      @closeModel="closeAddExtraUnitsModal"
      @addUnits="addUnits"
      @changeExtraUnitsState="extraUnitsState"
    />
    <!-------------------------------------------->
    <!---------Complete unit details modal-------->
    <!-------------------------------------------->
    <SingleUnitModel
      v-if="singleUnitDialogState"
      :dialogState="singleUnitDialogState"
      :propertyInfo="realEstate"
      :employees="employees"
      @changeDialogState="singleUnitDialogState"
      @closeDialog="closeAddDialog"
      @refresh-properties-list="getRealEstateDetails"
    />
    <PropertyApprovals
      v-if="showApprovalSettingsSideview"
      :propertyId="realEstate._id"
      :allEmployees="allEmployees"
      @openPAModal="openPAModal($event)"
      @closeDetails="showApprovalSettingsSideview = false"
    />

    <ApprovalModal
      v-if="showApprovalSettingModal"
      ref="PropertyApprovalModal"
      :dialogState="showApprovalSettingModal"
      :module="selectedModule"
      :allEmployees="allEmployees"
      :jobTitles="jobTitles"
      @setJobTitles="setJobId"
      @closeDialog="toggleApprovalModel"
      @loadMoreEmployees="getEmployeesNextData"
      @setEmployees="setEmployeesHandler"
    />
    <!------------------------------------------->
    <!-------------Add contract modal-------->
    <!-------------------------------------------->
    <addContractNewModal
      :contractModalState="showAddContractModal"
      :contractIntervals="contractIntervals"
      @closeContractModal="showAddContractModal = $event"
      @refreshContracts="closeAddDialog"
      :defaultData="defaultContractModalData"
      v-if="showAddContractModal"
    />
    <!------------------------------------------->
    <!-------------Add bond modal---------------->
    <!------------------------------------------->
    <AddBondModal
      v-if="showAddBondModal"
      @showAddBondModal="showAddBondModal = $event"
      v-bind="addBondProps"
      @closed-bond-dialog="closeAddDialog"
    />

    <ActivityLogsSideDetails
      v-if="showActivityLogs"
      v-bind="{ showActivityLogs, type: 'realestate' }"
      @closeActivityLogs="closeActivityLogs"
    />

    <!------------------------------------------->
    <!---------Expense Limit Modal--------------->
    <!------------------------------------------->
    <ExpensesLimitModal
      v-if="expensesLimitModal.dialogState"
      v-bind="expensesLimitModalProps"
      @closeExpensesLimitModal="changeExpensesModalState(false)"
      @saveExpensesLimit="saveExpensesLimit"
    />

    <!------------------------------------------->
    <!---------Bank Acounts Select Model--------->
    <!------------------------------------------->
    <bankAcountsSelectModel
      v-if="bankSelectModelDialogState"
      :dialogState="bankSelectModelDialogState"
      :realEstateBankAccounts="realEstateBankAccounts"
      :realEstate="realEstate"
      @changeDialogState="bankSelectModelDialogState = $event"
      @refreshBankAccounts="getRealestateBankAccounts"
    />

    <!----------------------------------->
    <!---------Responsible Modal--------->
    <!----------------------------------->
    <ResponsibleModal
      v-if="responsibleModalStatus"
      v-bind="responsibleModalProps"
      @closeModel="responsibleModalStatus = false"
      @reloadProperty="getRealEstateProperty"
      @nextPageTrigger="getEmployeesWithNoJobIdNextData"
    />
    <!--
    @addResponsible="addResponsibleHandler"
  -->

    <!----------------------------------->
    <!---------Beneficiary Modal--------->
    <!----------------------------------->
    <BeneficiaryModal
      v-if="beneficiaryModalStatus"
      v-bind="beneficiaryModalProps"
      @closeModel="closeModelHandler"
      @addBeneficiary="addBeneficiaryHandler"
    />

    <PropertyRate
      v-if="showRateModal"
      v-bind="{ realEstate, showRateModal }"
      @closeRateModel="showRateModal = $event"
      @updateRealEstate="updateRealEstate"
    />

    <EditUnitName
      v-if="showEditNameModal"
      :dialogState="showEditNameModal"
      :realEstate="realEstate"
      @closeDialog="setShowEditNameModal(false)"
      @updateName="updateName"
    />

    <AttachmentsModal
      v-if="attachmentModalStatus"
      v-bind="attachmentsModalProps"
      @close-dialog="attachmentModalStatus = false"
      @selectFile="addDocument"
    />
    <v-dialog v-model="isImageDialog" max-width="900">
      <div class="position-relative">
        <img :src="imageDialogPath" alt="image dialog" style="display: block" />
        <div
          @click="isImageDialog = false"
          class="pic-icon position-absolute slide-y-transition"
          color="white"
        >
          <img src="@/assets/Icons_Legacy/close.svg" alt="mdi-close" />
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<style>
.sidedetails__layout .v-slide-group.v-tabs-bar.primary--text {
  border-radius: 10px 10px 0 0 !important;
}

.sidedetails__layout .theme--light.v-tabs-items {
  border-radius: 0 0 10px 10px !important;
}
</style>

<script>
import addContractNewModal from '@/components/add-contract/contractModal'
import SingleUnitModel from '@/components/add-unit/unitModelTabs/singleUnitModel'
import ClientDetailsInfoCard from '@/components/details/ClientDetailsInfoCard'
import ClientDetailsRealEstateList from '@/components/details/ClientDetailsRealEstateList'
import ClientDetailsTiles from '@/components/details/ClientDetailsTiles'
import ClientDetailsToolbar from '@/components/details/ClientDetailsToolbar'
import FileListCard from '@/components/details/FileListCard'
import { default as ReceivedDeposit } from '@/components/details/ReceivedDeposit'
import ResponsiblePersonsTable from '@/components/details/ResponsiblePersonsTable.vue'
import { default as Loader } from '@/components/helper/loader.vue'
import { default as ToolBar } from '@/components/listing/ToolBar'
import {
  bondsService,
  contractsService,
  EnvService,
  realEstateService,
  userService
} from '@/services'
import { buildQueryString } from '@/utils/general'
import { mapGetters, mapMutations, mapState } from 'vuex'
import BlueprintImages from '../components/details/BlueprintImages'
import DetailsSlider from '../components/details/DetailsSlider'
import DetailsTabs from '../components/details/detailsTabs'
import expenseLimit from '../components/details/expenseLimit.vue'

export default {
  name: 'PropertyDetails',
  components: {
    AddBondModal: () => import('@/components/modals/AddBondModal.vue'),
    PropertyRate: () => import('@/components/properties/PropertyRate.vue'),
    PropertyApprovals: () =>
      import('@/components/properties/propertyApprovals.vue'),
    ApprovalModal: () => import('@/components/properties/ApprovalModal.vue'),
    unitModal: () => import('@/components/add-unit/unitModal'),
    ActivityLogsSideDetails: () =>
      import('@/components/ActivityLogs/ActivityLogsSideDetails'),
    addExtraUnits: () =>
      import('@/components/add-unit/unitModelTabs/addExtraUnits'),
    BeneficiaryModal: () => import('@/components/modals/BeneficiaryModal.vue'),
    ResponsibleModal: () => import('@/components/modals/ResponsibleModal.vue'),
    AttachmentsModal: () =>
      import('@/components/contracts/SideDetails/AttachmentsModal.vue'),
    ResponsiblePersonsTable,
    DetailsTabs,
    DetailsSlider,
    ClientDetailsToolbar,
    ClientDetailsRealEstateList,
    ClientDetailsTiles,
    FileListCard,
    ClientDetailsInfoCard,
    SingleUnitModel,
    BlueprintImages,
    addContractNewModal,
    expenseLimit,
    ExpensesLimitModal: () =>
      import('@/components/modals/ExpensesLimitModal.vue'),
    bankAcountsSelectModel: () =>
      import('@/components/core/bankAcountsSelectModel.vue'),
    Loader,
    ReceivedDeposit,
    ToolBar,
    EditUnitName: () => import('@/components/modals/EditUnitName.vue')
  },
  data: () => {
    return {
      bankSelectModelDialogState: false,
      realEstateBankAccounts: [],
      cardsInfoState: true,
      allTabs: { tab1: 0, tab2: 0 },
      datesQuery: {
        startDate: '',
        endDate: ''
      },
      updatedBeneficiary: {},
      isPageLoading: false,
      extraUnitsState: false,
      showAddBondModal: false,
      showApprovalSettingsSideview: false,
      showApprovalSettingModal: false,
      showAddContractModal: false,
      selectedModule: {},
      allEmployeesWithNoJobId: [],
      allEmployees: {},
      jobTitles: [],
      level: null,
      paginationEmployees: {
        pageNumber: 1,
        pagesCount: 0,
        pageSize: 15,
        count: 0
      },
      paginationEmployeesWithNoJobId: {
        pageNumber: 1,
        pagesCount: 0,
        pageSize: 9,
        count: 0
      },
      isLoadingEmployees: false,
      editedBond: {},
      singleUnitDialogState: false,
      realEstate: null,
      bonds: [],
      contracts: [],
      realEstates: [],
      tabsTitles: ['المالك', ' المستأجرين', 'المستفيدين', 'الحسابات البنكية'],
      dialogState: false,
      parent: '',
      addNewOwner: false,
      bondsAvailableTypes: [],
      employees: [],
      allDocuments: [],
      parentProperty: {},
      showActivityLogs: false,
      showRateModal: false,
      responsiveActions: [
        {
          name: 'سجل نشاطات العقار',
          color: 'teal',
          icon: require('@/assets/Icons_Legacy/activity-active.svg'),
          imgResponsive: require('@/assets/Icons_Legacy/activity-active.svg'),
          method: 'showActivityLogs'
        },
        {
          name: 'إضافة عقد',
          icon: require('@/assets/Icons_Legacy/docs.svg'),
          method: 'showAddContractModal',
          title: 'contracts',
          needPermession: true
        },
        {
          name: 'إضافة سند',
          icon: require('@/assets/Icons_Legacy/clipboard.svg'),
          method: 'showAddBondModal',
          title: 'bonds',
          needPermession: true
        }
      ],
      contractIntervals: [],
      expensesLimitModal: {
        dialogState: false,
        isSaveProcessFailed: false
      },
      tabs: [
        { title: 'مصروفات الصيانة', component: 'expenseLimit' },
        { title: 'العهُدة المستلمة', component: 'ReceivedDeposit' }
      ],
      tab: 0,
      responsibleModalStatus: false,
      beneficiaryModalStatus: false,
      clientRoles: {
        renter: 'tenet',
        owner: 'owner'
      },
      showEditNameModal: false,
      isImageDialog: false,
      imageDialogPath: '',
      attachmentModalStatus: false
    }
  },
  async created() {
    this.$emit('updateInformativeTip', this.$route.meta?.informativeTip)
    await this.getRealEstateDetails()
    await this.getBondsTypes()
    this.loadEmployees()
    this.getContractIntervals()
    await this.getRealestateBankAccounts()
    await this.getAllJobsTitles()
  },
  watch: {
    '$route.params': {
      async handler() {
        await this.getRealEstateDetails()
      }
    }
  },
  computed: {
    ...mapState('accountState', [
      'currentEnv',
      'user',
      'customerDefaultRole',
      'subscription'
    ]),
    ...mapGetters('accountState', ['isCustomer']),
    renderTabs1() {
      return [
        {
          title: this.isUnitProperty ? 'معلومات الوحدة' : 'معلومات العقار',
          component: 'ClientDetailsInfoCard'
        },
        {
          title: 'المسؤولين',
          component: 'ResponsiblePersonsTable'
        }
      ]
    },
    actions() {
      const actions = [
        {
          name: 'تفعيل الإشعارات',
          method: 'toggleNotificationStatus',
          isSwitchBtn: true,
          value: 'notificationStatus',
          toolTip: 'قم بتفعيل الإشعارات من الإعدادات أولا',
          disabled: 'isGlobalNotification'
        }
      ]
      if (this.$hasPermission('realestates', 'propertyEvaluation', 'update')) {
        actions.unshift(this.rateBtn)
      }
      if (
        this.$hasPermission('realestates', 'realestates', 'update') &&
        !this.realEstate?.parentId?.length
      ) {
        actions.push(this.propertyApprovalBtn)
      }
      return actions
    },
    isRealEstateRented() {
      return this.realEstate.status.nameEn === 'rented'
    },
    contractIndex() {
      return this.contracts.findIndex((contract) =>
        ['active', 'rentDraft'].includes(contract.status)
      )
    },
    realEstateBeneficiary() {
      return this.contracts[this.contractIndex]?.beneficiary || {}
    },
    contractId() {
      return (
        this.contracts.find((contract) =>
          ['active', 'rentDraft'].includes(contract.status)
        )?._id || null
      )
    },
    isEditBankAllowed() {
      return (
        !this.realEstate?.parentId?.length && this.hasListBankAccountsPermission
      )
    },
    hasAttacheRealStateImagesPermission() {
      return this.subscription.bundle.code !== 'free-bundle'
    },
    hasListBankAccountsPermission() {
      return !!this.$hasPermission('users', 'bankAccountsSettings', 'list')
    },
    listContractPermission() {
      return !!this.$hasPermission('properties', 'contracts', 'list')
    },
    listBondPermission() {
      return !!this.$hasPermission('properties', 'bonds', 'list')
    },
    clientDetailsTilesProps() {
      return {
        contractsResponse: this.contracts.length,
        realestateOwner: this.realEstate.owner._id,
        typeName: this.realEstate.type.nameEn,
        isCustomer: this.isCustomer,
        datesQuery: {
          startDate:
            this.datesQuery?.startDate ||
            new Date(new Date().setMonth(new Date().getMonth() - 1)),
          endDate: this.datesQuery?.endDate || new Date()
        }
      }
    },
    toolBarProps() {
      return {
        breadcrumbs: this.isUnitProperty
          ? this.parentPropertyBreadcrumbs
          : this.breadcrumbs,
        showDateFilter: !!(
          this.isPartiallyRented || this.realEstateStatusEn === 'rented'
        ),
        title: this.realEstate.name,
        cardsInfoState: this.cardsInfoState,
        showEditBtn: this.isUnitProperty
      }
    },
    addBondProps() {
      return {
        dialogState: this.showAddBondModal,
        editedBond: this.editedBond,
        defaultValues: {
          realEstate: this.parentProperty?._id
            ? this.parentProperty
            : this.realEstate,
          unit: this.parentProperty?._id ? this.realEstate : {},
          setClickedTag: 'owner'
        }
      }
    },
    isEnvOwner() {
      return (
        !!this.currentEnv?.isOwner ||
        !!(this.currentEnv?.employeeRole === 'owner')
      )
    },
    defaultContractModalData() {
      return this.realEstate?.rentContract ||
        this.realEstate?.rentedUnitsCount > 0
        ? this.realEstate?.owner
        : this.realEstate
    },
    clientDetailsInfoCardProps() {
      return {
        realEstate: {
          completePercentage: this.parentProperty.completePercentage,
          ...this.realEstate,
          title: 'معلومات العقار'
        },
        isEnvOwner: this.isEnvOwner,
        isCustomer: this.isCustomer
      }
    },
    loaderProps() {
      return {
        laoderClasses: 'mx-auto',
        type: 'list-item-avatar-three-line, divider, list-item-two-line, divider, table-tfoot',
        numberOfLines: 8
      }
    },
    propertyId() {
      return this.$route.params.id || undefined
    },
    contractsRequestPayload() {
      const payload = {
        realEstate: this.propertyId,
        ...(this.isCustomer && {
          users: this.user?._id,
          userType: this.clientRoles[this.customerDefaultRole]
        })
      }
      return payload
    },
    bondsRequestPayload() {
      const payload = {
        realEstate: this.propertyId,
        ...(this.isCustomer && {
          user: this.user?._id,
          userType: this.clientRoles[this.customerDefaultRole]
        })
      }
      return payload
    },
    HectarBtn() {
      const realEstateHectarLink = {
        name: 'اعرض في هكتار',
        color: 'green',
        img: require('@/assets/Icons_Legacy/link.svg'),
        imgResponsive: require('@/assets/Icons_Legacy/link.svg'),
        method: 'openRealEstateHectarLink'
      }
      return realEstateHectarLink
    },
    rateBtn() {
      return {
        name: 'تقييم العقار',
        color: 'green',
        icon: 'mdi-check',
        img: require('@/assets/Icons_Legacy/property-info.svg'),
        class: 'font-weight-bold',
        props: { outlined: true },
        imgResponsive: '',
        method: 'showRateDailog'
      }
    },
    propertyApprovalBtn() {
      return {
        name: 'إعدادات الموافقات',
        method: 'showApprovalSettings',
        icon: 'mdi-cog-outline',
        img: require('@/assets/Icons_Legacy/settings.svg'),
        isSwitchBtn: false,
        value: 'approvalSettings',
        toolTip: 'إعدادات الموافقات الخاصه بهذا العقار فقط',
        class: 'text--737373 font-14 font-weight-bold px-0',
        btnText: true
      }
    },
    parentPropertyBreadcrumbs() {
      return [
        {
          text: ' قائمة العقارات',
          disabled: false,
          exact: true,
          link: true,
          to: {
            name: 'properties',
            params: {
              addNewProperty: 0
            }
          }
        },
        {
          text: this.parentProperty?.propertyName,
          disabeled: false,
          exact: true,
          link: true,
          to: {
            path: `/dashboard/property-details/${
              this.parentProperty?._id
            }?parent=${
              this.parentProperty?.parentId
                ? this.parentProperty?.parentId
                : this.parentProperty?._id
            }`
          }
        },
        {
          text: this.realEstate?.name,
          disabled: true
        }
      ]
    },
    responsibleModalProps() {
      return {
        dialogState: this.responsibleModalStatus,
        realEstateId: this.realEstate._id,
        employees: this.allEmployeesWithNoJobId,
        selectedResponsibles: this.tabsMembersData?.[2],
        isLoadingEmloyees: this.isLoadingEmployees
      }
    },
    beneficiaryModalProps() {
      return {
        dialogState: this.beneficiaryModalStatus,
        updated: this.updatedBeneficiary,
        clientId: this.tabsMembersData[1][0]._id,
        realEstateId: this.realEstate._id
      }
    },
    breadcrumbs() {
      return [
        {
          text: ' قائمة العقارات',
          disabled: false,
          exact: true,
          link: true,
          to: {
            name: 'properties',
            params: {
              addNewProperty: 0
            }
          }
        },
        {
          text: this.realEstate?.propertyName,
          disabled: true
        }
      ]
    },
    tabsMembersData() {
      return [
        [this.realEstate?.owner] ?? [
          {
            name: 'لا يوجد مالك لهذا العقار'
          }
        ],
        this.realEstate?.tenets ?? [
          {
            name: 'لا يوجد مستأجر'
          }
        ],
        this.realEstate?.moderators ?? [
          {
            name: 'لا يوجد مستفيدين'
          }
        ]
      ].filter(Boolean)
    },
    parentId() {
      return this.$route.query?.parent
    },
    realEstateNameAR() {
      return this.realEstate?.propertyName ?? ''
    },
    realEstateType() {
      return this.realEstate?.type.nameAr ?? ''
    },
    realEstateStatusEn() {
      return this.realEstate?.status?.nameEn ?? ''
    },
    isPartiallyRented() {
      return this.realEstate?.rentedUnitsCount ?? 0
    },
    buildingType() {
      return this.realEstate?.type ?? {}
    },
    propertyToSend() {
      const dataToSend = {
        parentId: this.realEstate?._id
      }
      return dataToSend
    },
    clientToolbarProps() {
      return {
        contractsResponse: this.contracts.length,
        realEstatesResponse: this.realEstates.length,
        actions: this.actions,
        toolbarInfo: {
          ...this.realEstate,
          completePercentage: this.parentProperty.completePercentage
        },
        responsiveActions: this.responsiveActions,
        showHideHectarAction: this.showHideHectarAction
      }
    },
    detailsTabsProps() {
      return {
        files: this.tabsMembersData,
        tabs: this.tabsTitles,
        realEstateBankAccounts: this.realEstateBankAccounts,
        realEstateBankAccountsLoading: this.realEstateBankAccountsLoading,
        isEditBankAllowed: this.isEditBankAllowed,
        beneficiary: this.realEstateBeneficiary
      }
    },
    listBondsProps() {
      return {
        files: this.bonds,
        subTitle: 'bond',
        link: {
          name: 'إظهار كل سندات العقار',
          url: '/dashboard/bonds',
          realEstate: {
            _id: this.realEstate?._id,
            propertyName: this.realEstate?.propertyName
          }
        },
        hasAddPermission: this.$hasPermission('properties', 'bonds', 'add'),
        modal: 'showAddBondModal',
        componentName: 'ClientDetailsFileList',
        noData: this.listBondPermission
          ? 'لا توجد سندات مرسله لهذا العقار'
          : 'ليس لديك صلاحية لتصفح السندات',
        title: 'قائمة السندات'
      }
    },
    listContractsProps() {
      return {
        files: this.contracts,
        subTitle: 'contract',
        link: {
          name: 'إظهار كل عقود العقار',
          url: '/dashboard/contracts',
          realEstate: {
            _id: this.realEstate?._id,
            propertyName: this.realEstate?.propertyName,
            status: this.realEstate?.status?.nameEn
          }
        },
        hasAddPermission: this.$hasPermission('properties', 'contracts', 'add'),
        componentName: 'ClientDetailsFileList',
        noData: this.listContractPermission
          ? 'لا توجد عقود مرسله لهذا العقار'
          : 'ليس لديك صلاحيه لتصفح العقود',
        title: 'قائمة العقود',
        modal: 'showAddContractModal'
      }
    },
    listDocumentsProps() {
      return {
        files: this.allDocuments,
        showDocuments: true,
        hasAddPermission: true,
        componentName: 'ClientDetailsFileList',
        noData: 'لا توجد وثائق مرسله لهذا العقار',
        title: 'قائمة الوثائق',
        modal: 'documentFileUploader'
      }
    },
    isShownInHectar() {
      return this.realEstate?.showInHectar
    },
    showHideHectarAction() {
      return {
        name: this.isShownInHectar ? 'إخفاء من هكتار' : 'إظهار في هكتار',
        icon: this.isShownInHectar
          ? require('@/assets/Icons_Legacy/eye-closed.svg')
          : require('@/assets/Icons_Legacy/eye.svg'),
        method: 'changeShowInHectar'
      }
    },
    hasUnits() {
      return !!this.realEstate?.unitsCount
    },
    realEstatePurpose() {
      return this.realEstate?.purpose?.nameEn
    },
    isRealEstateHasUnits() {
      return (
        this.realEstateType === 'عمارة' ||
        this.realEstateType === 'مجمع' ||
        this.realEstateType === 'برج' ||
        this.realEstateType === 'مبنى' ||
        this.realEstateType === 'فيلا'
      )
    },
    realEstateExpenseLimit() {
      return this.realEstate?.expenseLimit ?? null
    },
    expensesLimitModalProps() {
      return {
        dialogState: this.expensesLimitModal.dialogState,
        isSaveExpenseLimitFailed: this.expensesLimitModal.isSaveProcessFailed,
        expenseLimit: this.realEstateExpenseLimit
      }
    },
    isUnitProperty() {
      return !!Object.keys(this.parentProperty || {}).length
    },
    attachmentsModalProps() {
      return {
        ref: 'attachmentModal',
        dialogState: this.attachmentModalStatus,
        isLoading: false,
        isNumberNeeded: false,
        attachTypes: [
          'صك الملكية',
          'العنوان الوطني',
          'شهادة إتمام البناء',
          'شهادة إتمام الدفاع المدني',
          'مخطط السلامة',
          'المخطط المعماري'
        ]
      }
    }
  },
  methods: {
    ...mapMutations('appState', ['addNotification']),
    async getRealestateBankAccounts() {
      this.realEstateBankAccountsLoading = true
      try {
        const { data } = await EnvService.getRealestateBankAccounts({
          realEstateId: this.realEstate?._id,
          parentId: this.realEstate?.parentId,
          environmentId: this.currentEnv?._id
        })
        this.realEstateBankAccounts =
          data.realestateBankAccounts?.bankAccounts ?? []
      } catch {
        this.addNotification({
          text: 'لم نتمكن من تحميل حسابات العقار',
          color: 'error'
        })
      } finally {
        this.realEstateBankAccountsLoading = false
      }
    },
    async addBeneficiaryHandler(beneficiary) {
      this.$set(this.contracts[this.contractIndex], 'beneficiary', beneficiary)
    },
    toggleShowStats() {
      this.cardsInfoState = !this.cardsInfoState
    },
    setDate({ dateType, date }) {
      this.cardsInfoState = true
      this.datesQuery[`${dateType}`] = date
      this.refreshState += 1
    },
    closeModelHandler() {
      this.beneficiaryModalStatus = false
      this.updatedBeneficiary = {}
    },
    updateRealEstate(realEstate) {
      const { price, pricePerMeter, space } = realEstate
      this.realEstate = {
        ...this.realEstate,
        price,
        pricePerMeter,
        space
      }
    },
    editBeneficiaryHandler({ item }) {
      this.updatedBeneficiary = item
      this.beneficiaryModalStatus = true
    },
    deleteBeneficiaryHandler() {
      this.$root.$confirm
        .open({
          title: 'هل انت متاكد من حذف المستفيد',
          message: 'الرجاء إختيار نعم في حالة الرغبة في حذف المستفيد',
          options: {
            color: 'red'
          }
        })
        .then((confirm) => {
          if (confirm) {
            this.deleteBeneficiary()
          }
        })
    },
    async deleteBeneficiary() {
      this.deleted = false
      try {
        await EnvService.deleteBeneficiarieForContract({
          environment: this.currentEnv._id,
          contract: this.contractId
        })
        this.addNotification({
          text: 'تم حذف المستفيد بنجاح',
          color: 'success'
        })
        this.contracts[this.contractIndex].beneficiary = {}
      } catch {
        this.addNotification({
          text: 'حدث خطأ أثناء حذف المستفيد',
          color: 'error'
        })
      }
    },
    async getContractIntervals() {
      try {
        const Response = await contractsService.getContractIntervals()
        this.contractIntervals = Response.data.intervals
      } catch {
        this.addNotification({
          text: 'لم نتمكن من تحميل فترات العقد, برجاء المحاوله لاحقا',
          color: 'error'
        })
      }
    },
    async getRealEstateDetails() {
      this.isPageLoading = true
      try {
        const [
          realEstateResponse,
          contractsResponse,
          bondsResponse
          // documentsResponse
        ] = await Promise.all([
          await realEstateService.getSingleProperty(this.propertyId),
          await contractsService.getContracts(this.contractsRequestPayload),
          await bondsService.getAllBonds(this.bondsRequestPayload)
          // await realEstateService.getDocuments(this.propertyId)
        ])
        this.realEstate = realEstateResponse?.data?.realEstate ?? []
        this.contracts = contractsResponse?.data?.contracts ?? []
        this.allDocuments =
          realEstateResponse?.data?.realEstate?.attachments.map((el) => {
            return { ...el, mapedType: el.attachmentType }
          }) ?? []
        this.bonds = bondsResponse.data.bonds
        if (this.realEstate?.parentId) {
          await realEstateService
            .getSingleProperty(this.realEstate.parentId)
            .then((res) => {
              this.parentProperty = res.data.realEstate
            })
        } else {
          this.parentProperty = {}
        }
        this.addHectarLinkAction()
        this.setActionsPerConditions()
      } catch {
        this.addNotification({
          text: 'خطأ في استرجاع بيانات العقار',
          color: 'error'
        })
      } finally {
        this.isPageLoading = false
      }
    },
    async getRealEstateProperty() {
      const realEstateResponse = await realEstateService.getSingleProperty(
        this.propertyId
      )
      this.realEstate = realEstateResponse?.data?.realEstate ?? []
    },
    async getBondsTypes() {
      try {
        const bondTypes = await bondsService.bondsType()
        this.bondsAvailableTypes = bondTypes.data.bondsType
      } catch (err) {
        this.addNotification({
          text: err,
          color: 'error'
        })
      }
    },
    openDialogState(val, addNewOwner) {
      this.dialogState = val
      this.addNewOwner = !!addNewOwner
    },
    async closeAddDialog() {
      this.dialogState = false
      this.singleUnitDialogState = false
      this.showAddContractModal = false
      this.showAddBondModal = false
      await this.getRealEstateDetails()
    },
    async loadEmployees() {
      const param = buildQueryString(
        {
          pageSize: this.paginationEmployeesWithNoJobId.pageSize,
          pageNumber: this.paginationEmployeesWithNoJobId.pageNumber,
          registered: 1,
          ...(this.jobId && { jobId: this.jobId })
        },
        '&'
      )

      this.isLoadingEmployees = true
      await EnvService.getAllEmployee(this.currentEnv._id, param)
        .then((res) => {
          this.allEmployeesWithNoJobId = [
            ...this.allEmployeesWithNoJobId,
            ...res.data.users
          ]
          this.paginationEmployeesWithNoJobId.pagesCount = Math.ceil(
            res.data?.count / this.paginationEmployeesWithNoJobId.pageSize
          )
          this.paginationEmployeesWithNoJobId.count = res.data?.count ?? 0
        })
        .catch((err) => console.log('err', err))
        .finally(() => {
          this.isLoadingEmployees = false
        })
    },
    openApprovalSettings() {
      this.showApprovalSettingsSideview = true
    },
    openPAModal(item) {
      this.selectedModule = { ...item, property: this.realEstate._id }
      this.showApprovalSettingModal = true
    },
    openAddContractModal() {
      this.showAddContractModal = true
    },
    openAddBondModal() {
      this.showAddBondModal = true
    },
    async addUnits(unitsData) {
      const reqBody = {
        ...unitsData,
        ...this.propertyToSend,
        environment: this.currentEnv._id
      }
      try {
        await realEstateService.addUnits(reqBody)
        this.addNotification({
          text: `تم إضافه وحداتك بنجاح`,
          color: 'success'
        })
        this.extraUnitsState = false
        await this.getRealEstateDetails()
        this.$refs.innerUnits.getOwnerRealEstates()
      } catch (error) {
        this.addNotification({
          text:
            error.response?.data?.errors?.[0] ||
            error.message ||
            'something went wrong',
          color: 'error'
        })
      }
    },
    openAttachmentsModalHandler() {
      this.attachmentModalStatus = true
      this.sideViewStatus = false
      // this.representativeData = {}
    },
    async addDocument(attachment) {
      try {
        const { files, type } = attachment
        const fd = new FormData()
        fd.append('attachment', files, files.name)
        fd.append('attachmentType', type)
        fd.append('realEstateId', this.realEstate._id)
        this.$refs.attachmentModal.isLoading = true
        const { data } = await realEstateService.addDocument(fd)
        data.mapedType = data.attachmentType
        this.allDocuments.unshift(data)
        this.addNotification({
          text: 'تم إضافة الوثيقة بنجاح',
          color: 'success'
        })
      } catch (error) {
        if (error.response.data.error === 'feature not allowed') {
          this.addNotification({
            text: 'اضافة الوثائق غير متاحه في الباقة الحالية، يجب الترقية لتتمكن من اضافة الوثائق',
            color: 'error'
          })
        } else {
          this.addNotification({
            text: 'لم يتم إضافة الوثيقة يرجى المحاولة مره اخرى',
            color: 'error'
          })
        }
      } finally {
        this.$refs.attachmentModal.isLoading = false
      }
    },
    async toggleHectarVisibility() {
      const accountId = {
        account: {
          id: this.realEstate.account?.id
        }
      }
      try {
        const { data } = await realEstateService.toggleVisibility({
          realEstateId: this.realEstate._id,
          accountId
        })
        this.realEstate.showInHectar = data.showInHectar
        this.addHectarLinkAction()
        this.addNotification({
          text: this.isShownInHectar
            ? 'تم إظهار العقار في هكتار'
            : 'تم إخفاء العقار من هكتار',
          color: 'success'
        })
      } catch {
        this.addNotification({
          text: 'حدث خطأ ما برجاء المحاوله مجددا',
          color: 'error'
        })
      }
    },
    openActivityLogsModal() {
      this.showActivityLogs = true
    },
    changeShowHectar() {
      if (['sold', 'rented'].includes(this.realEstateStatusEn)) {
        this.addNotification({
          text: 'لايمكن اظهار العقارات المباعة والمستأجرة في هكتار',
          color: 'error'
        })
      } else {
        this.toggleHectarVisibility()
      }
    },
    setActionsPerConditions() {
      const addUnitAction = {
        name: 'إضافة وحدات',
        icon: require('@/assets/Icons_Legacy/home.svg'),
        method: 'addNewUnit'
      }
      if (
        this.isRealEstateHasUnits &&
        this.$hasPermission('realestates', 'realestates', 'add')
      ) {
        if (this.responsiveActions[0].name === 'إضافة وحدات') {
          return
        }
        this.responsiveActions.unshift(addUnitAction)
      } else {
        this.responsiveActions = this.responsiveActions.filter((action) => {
          return action.method !== 'addNewUnit'
        })
      }
    },
    async deleteDocument(fileDetails) {
      try {
        const data = {
          key: fileDetails.fileId,
          realEstateId: this.realEstate._id
        }
        await realEstateService.deleteDocument(data)
        this.allDocuments.splice(fileDetails.fileIndex, 1)
        this.addNotification({
          text: 'تم حذف الوثيقه بنجاح',
          color: 'success'
        })
      } catch {
        this.addNotification({
          text: 'حدث خطأ ما برجاء المحاوله مرة اخرى',
          color: 'error'
        })
      }
    },
    updatePropertyImages(images) {
      this.realEstate.images = images
    },
    setBlueprintImage(images) {
      this.realEstate.bluePrint = images
    },
    closeActivityLogs() {
      this.showActivityLogs = false
    },
    addHectarLinkAction() {
      const isHectarBtnExisted = this.actions.find(
        (action) => action.method === 'openRealEstateHectarLink'
      )

      if (
        this.isShownInHectar &&
        !isHectarBtnExisted &&
        this.$hasPermission('realestates', 'realestates', 'add')
      ) {
        // this.actions.unshift(this.HectarBtn)
      } else if (!this.isShownInHectar) {
        this.actions = this.actions.filter((action) => {
          return action.method !== 'openRealEstateHectarLink'
        })
      }
    },
    closeAddExtraUnitsModal() {
      this.extraUnitsState = false
    },
    changeExpensesModalState(val) {
      this.$set(this.expensesLimitModal, 'dialogState', val)
    },
    async saveExpensesLimit(_expenseLimit) {
      this.$set(this.expensesLimitModal, 'isSaveProcessFailed', false)
      try {
        const body = {
          _id: this.realEstate._id,
          environment: this.currentEnv._id,
          expenseLimit: _expenseLimit
        }
        await realEstateService.updateRealEstate(body)
        this.$set(this.realEstate, 'expenseLimit', _expenseLimit)
        this.addNotification({
          text: 'تم تعديل الحد الأقصى للمستحقات بنجاح',
          color: 'success'
        })
        this.changeExpensesModalState(false)
      } catch {
        this.$set(this.expensesLimitModal, 'isSaveProcessFailed', true)
        this.addNotification({
          text: 'خطأ في تعديل الحد الأقصى للمستحقات، يرجى المحاولة مجددا',
          color: 'error'
        })
      }
    },
    generateTabProps(tab) {
      let requiredProps = {}
      if (tab.component === 'expenseLimit') {
        requiredProps = {
          hasAddPermission: this.$hasPermission(
            'properties',
            'contracts',
            'add'
          ),
          expenseLimit: this.realEstateExpenseLimit
        }
      } else {
        requiredProps.realEstateId = this.realEstate?._id
      }
      return requiredProps
    },
    async setJobId(id, level) {
      this.level = level
      this.jobId = id
      this.$refs.PropertyApprovalModal.$data.loading[`status${level}`] = true
      await this.loadAllEmployees()
      this.$refs.PropertyApprovalModal.$data.loading[`status${level}`] = false
    },
    setEmployeesHandler(users) {
      Object.entries(users).forEach(([, user], index) => {
        if (user) {
          this.$set(this.allEmployees, `level${index + 1}`, [user])
        }
      })
    },
    async getEmployeesNextData() {
      if (
        this.paginationEmployees.pageNumber <
        this.paginationEmployees.pagesCount
      ) {
        this.paginationEmployees.pageNumber += 1
        await this.loadAllEmployees()
      }
    },
    async getEmployeesWithNoJobIdNextData() {
      if (
        this.paginationEmployeesWithNoJobId.pageNumber <
        this.paginationEmployeesWithNoJobId.pagesCount
      ) {
        this.paginationEmployeesWithNoJobId.pageNumber += 1
        await this.loadEmployees()
      }
    },
    toggleApprovalModel(state) {
      this.showApprovalSettingModal = state.dialogState
      // this.updateStatus = false
      this.cardsInfoState = {}
      this.cardsInfoState = null
      if (state.approval) {
        this.selectedModule = state.approval
      }
    },
    updateEmployees(data) {
      // Get users who has jobId
      const filteredUsers = data?.users?.filter(
        (user) => user.environments?.[0]?.jobId?._id
      )
      this.$set(this.allEmployees, `level${this.level}`, filteredUsers)
    },
    async loadAllEmployees() {
      try {
        const param = buildQueryString(
          {
            pageSize: this.paginationEmployees.pageSize,
            pageNumber: this.paginationEmployees.pageNumber,
            registered: 1,
            ...(this.jobId && { jobId: this.jobId })
          },
          '&'
        )
        this.isLoadingEmployees = true
        const { data } = await EnvService.getAllEmployee(
          this.currentEnv._id,
          param
        )
        this.calculatePagination(data)
        await this.updateEmployees(data)
        this.isLoadingEmployees = false
      } catch {
        this.addNotification({
          text: 'خطأ في تحميل المسئولين',
          color: 'error',
          duration: 4000
        })
      }
    },
    async getAllJobsTitles() {
      const query = buildQueryString({
        environmentId: this.currentEnv?._id
      })
      try {
        const { data } = await EnvService.getJobTitles(query)
        this.jobTitles = data.envJobTitles
      } catch {
        this.addNotification({
          text: 'خطأ في تحميل الموظفين',
          color: 'error',
          duration: 4000
        })
      }
    },
    calculatePagination(data) {
      this.paginationEmployees.pagesCount = Math.ceil(
        data?.count / this.paginationEmployees.pageSize
      )
      this.paginationEmployees.count = data?.count ?? 0
    },
    setShowEditNameModal(state) {
      this.showEditNameModal = state
    },
    updateName(name) {
      this.$set(this.realEstate, 'name', name)
      this.setShowEditNameModal(false)
    },
    openImageDialog(path) {
      this.imageDialogPath = path
      this.isImageDialog = true
    }
  },
  metaInfo() {
    return {
      title: 'تفاصيل العقار'
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/material-dashboard/_properties.scss';
@import '@/styles/material-dashboard/_team.scss';

.v-btn.add-btn {
  border-radius: 7px !important;

  &.add__property__btn {
    height: 20px;
    min-width: 24px;

    &:hover {
      // background: $primary-color !important;

      i {
        color: #fff !important;
      }
    }

    ::v-deep {
      .v-btn__content {
        i {
          font-size: 17px !important;
        }
      }
    }
  }

  // add__property__btn
}

.page-main-bg {
  background-color: #f7f7f7;
}

.v-breadcrumbs li:nth-child(2n) {
  padding: 0 8px;

  img {
    height: 10px;
    width: 10px;
  }
}

.document__bond__contract__list__cards {
  @include max-xl {
    h5,
    .h5 {
      font-size: 0.6rem !important;
    }

    h6,
    .h6 {
      font-size: 0.55rem !important;
    }
  }
}

.tabs-container {
  ::v-deep {
    .v-slide-group__content {
      justify-content: space-between;
    }
  }
}
</style>
